import React from "react";
import { IconType } from "react-icons";

type Props = {
  icon: IconType;
  title: string;
  id: number;
  // The action buttons, shown on the right.
  children?: React.ReactNode;
};

// The top of a detail card: the module's icon in a tinted box, its name and the record's ID, and the actions.
const DetailHeader = ({ icon: Icon, title, id, children }: Props) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div className="flex min-w-0 items-center gap-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#113F67]/10">
        <Icon className="h-6 w-6 text-[#113F67]" />
      </div>

      <div className="min-w-0">
        <h2 className="text-2xl font-bold text-[#113F67]">{title}</h2>
        <p className="text-sm text-gray-500">ID: {id}</p>
      </div>
    </div>

    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export default DetailHeader;
